import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Fade from '@material-ui/core/Fade';
import { styles } from '../../styles/drawer-list-styles';
import Alert from '../Alert/Alert';
import Loading from '../Loading';
import { createAlerts } from './createAlerts';

class AlertList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertListItems: []
    }
  }
  setAlertListItems = () => {
    const { alerts, handleUpdateAlert, type } = this.props;
    this.setState({
      alertListItems: createAlerts(alerts, handleUpdateAlert, type)
    })
  }
  componentDidMount() {
    this.setAlertListItems()
  }
  componentDidUpdate(prevProps) {
    if(prevProps.alerts !== this.props.alerts) {
      this.setAlertListItems();
    }
  }
  render() {
    return (
    <Fade in={true} timeout={1500}>
      <div style={{ width: "100%" }}>
        <List>
        {this.state.alertListItems}
        </List>
      </div>
    </Fade>
    
    );    
  }
}

AlertList.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(AlertList);


// WEBPACK FOOTER //
// ./src/components/AlertList/AlertList.js